import { CONSTANTS } from '../../data.js';

/**
 * Memoized map of era keys to their index for sorting/comparison.
 * Useful for determining "current era" or ordering by timeline.
 */
export const eraIndexByKey: Record<string, number> = (() => {
  const map: Record<string, number> = {};
  CONSTANTS.eras.list.forEach((e, i) => {
    if (e?.key) {
      map[e.key] = i;
    }
  });
  return map;
})();
